/* @flow */
import type { ActionsObservable } from 'redux-observable';

// NOTE: Once we refactor the alert action to be an action creator we should
// import it directly instead of making our own.
// import { alert } from './actions.js';
import { ADD_ALERT } from './action-types.js';

/**
 * TODO: Currently the alert component is responsible for removing alerts after
 * a set amount of time. We could handle this in a more elegant way here once we
 * fully refactor.
 */

const alert = payload => ({
  type: ADD_ALERT,
  payload,
});

const isAlert = x =>
  x && (typeof x.type === 'string') && (typeof x.text === 'string');

const hasAlert = action =>
  !!action.meta && isAlert(action.meta.alert);

const alertsEpic = (action$: ActionsObservable<*>) =>
  action$.filter(hasAlert)
    .map(x => alert(x.meta.alert));

export default alertsEpic;



// WEBPACK FOOTER //
// ./src/app/modules/alerts/epics.js